/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description: 
 */
import React from "react";
import PropTypes from "prop-types";
import shihuo from 'shihuo-lib/dist/shihuo-lib';
import utils from '../../../../../utils/utils';
import Request from "../../../../../utils/request";
import Swiper from 'swiper/swiper-bundle.min.js'
import 'swiper/swiper.less'
import "./style.less";

const isTabletDevice = utils.judgeIsTabletDevice();

class PipelineNavigationBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchWords: []
    };
    const { navigationBarPaddingTop, navigationBarHeight } = utils.getNavigationBarInfo();
    this.pageId = utils.getPageId();
    this.ref = null;
    this.backRef = null;
    this.shareRef = null;
    this.backDarkRef = null;
    this.shareDarkRef = null;
    this.backLightRef = null;
    this.shareLightRef = null;
    this.searchSwiper = null;
    this.searchGuideRef = null;
    this.navigationRef = null;
    this.navigationBarHeight = navigationBarHeight;
    this.navigationBarPaddingTop = navigationBarPaddingTop;
  }

  componentDidMount() {
    window && window.addEventListener('scroll', () => {
      let y = document.documentElement.scrollTop || document.body.scrollTop;
      y = y < 0 ? 0 : y;
      if (this.ref) {
        const opacity = y > 20 ? 1 : (y / 20).toFixed(2)
        this.ref.style.opacity = opacity;
        
        if (this.searchGuideRef) {
          this.searchGuideRef.style.opacity = 1 - opacity;
        }

        const { baseConfig } = this.props.config;
        if (baseConfig.navigatorBarTheme == '黑') {
          this.backDarkRef.style.opacity = opacity;
          this.shareDarkRef.style.opacity = opacity;
          this.backLightRef.style.opacity = 1 - opacity;
          this.shareLightRef.style.opacity = 1 - opacity;
        }
      }
      if (this.backRef) {
        const opacity = y > 20 ? 0 : (1 - (y / 20).toFixed(2)) * 0.2;
        this.backRef.style.backgroundColor = `rgba(0, 0, 0, ${opacity})`;
        this.shareRef.style.backgroundColor = `rgba(0, 0, 0, ${opacity})`;
      }
    });

    const { baseConfig } = this.props.config;
    const searchWords = baseConfig.searchWords ? baseConfig.searchWords.trim() : '';
    if (searchWords) {
      this.setState({
        searchWords: searchWords.split(',').filter(item => item !== '')
      }, () => {
        if (this.state.searchWords.length > 1) {
          this.searchSwiper = new Swiper('.search-swiper', {
            direction: 'vertical',
            autoplay: true,
            speed: 500,
            loop: true,
          });
        }
      });
    }

    if (this.navigationRef) {
      window.navigationBarHeight = this.navigationRef.clientHeight - 1;
    }
  }

  searchClick = (keywords) => {
    const url = `shihuo://www.shihuo.cn?route=homeSearch&placeholder=${encodeURIComponent(keywords || '搜索品牌 商品名')}`;
    const pageOptions = {
      component_id: this.props.customAttributes['data-component-id'],
      lego_page_id: this.pageId,
      legoAb: this.props.legoAb
    }
    shihuo.navigateWithTrack({
      url,
      pageOptions,
      pti: {
        id: 'lego-specialTopic:searchInput',
        name: '导航栏搜索',
        biz: JSON.stringify(pageOptions),
        pageOptions
      }
    })
  }

  backClick = () => {
    if(typeof window !== 'undefined'){
      if (utils.isShihuo()) {
        window.Jockey.send('windowClose');
      } else {
        window.history.back();
      }
    }
  }

  shareClick = () => {
    // 分享埋点
    const pageOptions = {
      component_id: this.props.customAttributes['data-component-id'],
      lego_page_id: this.pageId,
      legoAb: this.props.legoAb
    }
    shihuo.uploadTrack({
      pti: {
        id: 'lego-specialTopic:share',
        name: '导航栏分享',
        biz: JSON.stringify(pageOptions),
        pageOptions
      }
    })

    // 分享交互
    const { shareUrl, shareTitle, shareContent, shareImage } = this.props.config.baseConfig;
    const isStage = window.location.href.indexOf('/stage/page') >= 0;
    let pageRoute = '';
    if (!isStage) {
      pageRoute = `shihuo://www.shihuo.cn?route=fastWebview&navigationBar=false&url=${encodeURIComponent('https://zt-public.shihuo.cn/page/' + this.pageId + '/index.html')}`
    } else {
      pageRoute = `shihuo://www.shihuo.cn?route=fastWebview&navigationBar=false&url=${encodeURIComponent('https://zt-public.shihuo.cn/stage/page/' + this.pageId + '/index.html')}`
    }
    Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/share/get?access_token=znSnA7pxO35wtPBaur',
      method: "get",
      withCredentials: true,
      params: {
        page_id: this.pageId,
        title: shareTitle,
        desc: shareContent,
        url: pageRoute,
        img: shareImage
      },
    }).then(res => {
      const { status, data } = res.data;
      if (status === 0) {
        window.Jockey.send("share", {
          url: `${shareUrl}${shareUrl.indexOf('?') < 0 ? '?' : '&'}kl=${encodeURIComponent(data.kl)}`,
          title: shareTitle,
          content: shareContent,
          img: shareImage,
        });
      }
    })
  }

  render() {
    
    let { backgroundColor } = this.props;
    const { baseConfig } = this.props.config;
    const { searchWords = [] } = this.state;

    return (
      <div className="navigation-bar-wrapper" style={{transform: "translate3d(0, -1px, 0)"}} ref={ref => this.navigationRef = ref}>
        <div
          ref={ref => this.ref = ref}
          className="navigation-bar"
          {...this.props['customAttributes']}
          style={{
            paddingTop: this.navigationBarPaddingTop,
            height: this.navigationBarHeight + 1,
            backgroundColor: backgroundColor,
          }}
        >
          {
            baseConfig.searchBoxDisplay === '否' && (
              <div 
                className={`main-title ${isTabletDevice ? 'isTablet' : ''}`}
                style={{
                  color: baseConfig.navigatorBarTheme == '白' ? '#fff' : '#333'
                }}
              >
                {window.document.title}
              </div>
            )
          }
        </div>
        {
          baseConfig.searchBoxDisplay === '是' && (
            <div className={`search-bar-wrap ${isTabletDevice ? 'isTablet' : ''}`}>
              <div className="search-input-wrap">
                <img src="http://static.shihuocdn.cn/admin/files/20230719/b0f07e5bb669d06d8af1960fb2de96fc.png" alt="" className="search-icon" />
                {
                  searchWords.length <= 1 && <p className={`search-input ${isTabletDevice ? 'isTablet' : ''}`} onClick={() => this.searchClick(searchWords[0])}>{ searchWords.length <= 0 ? '搜索品牌 商品名' : searchWords[0] }</p>
                }
                {
                  searchWords.length > 1 && (
                    <div className="search-swiper swiper-container">
                      <div className="search-lottery-all swiper-wrapper">
                        {
                          searchWords.map((item, index) => {
                            return (
                              <div className="search-lottery-item swiper-slide" key={index} onClick={() => {
                                const url = `shihuo://www.shihuo.cn?route=homeSearch&placeholder=${encodeURIComponent(item)}`;
                                utils.jumpToUrl(this.props.routeParams, url, url, {}, -1, this.props, false);
                              }}>
                                {item}
                              </div>
                            )  
                          })
                        } 
                      </div>
                    </div>
                  )
                }
              </div>
              {
                baseConfig.searchGuideText
                  && baseConfig.searchGuideText.indexOf('<!--') < 0
                    && (
                      <p 
                        ref={ref => this.searchGuideRef = ref}
                        className={`search-guide ${isTabletDevice ? 'isTablet' : ''}`}
                        style={{color: baseConfig.searchGuideColor}}
                      >
                        {baseConfig.searchGuideText}
                      </p>
                    )
              }
            </div>
          )
        }
        <div
          className={`back-icon-wrap ${isTabletDevice ? 'isTablet' : ''}`}
          onClick={this.backClick}
        >
          <div className="back-icon-bg" ref={ref => this.backRef = ref}>
            <svg t="1657000722526" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1696" width="24" height="24" className="back-icon-light" ref={ref => this.backLightRef = ref}>
              <path d="M609.877333 97.962667A42.666667 42.666667 0 0 1 673.706667 154.453333l-3.541334 4.010667-353.792 352.426667 353.877334 355.242666a42.666667 42.666667 0 0 1-56.405334 63.786667l-4.010666-3.541333-353.92-355.285334a85.333333 85.333333 0 0 1-4.736-115.285333l4.992-5.418667 353.749333-352.384z" p-id="1697" fill="#ffffff"></path>
            </svg>
            <svg t="1657000722526" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1696" width="24" height="24" className="back-icon-dark" ref={ref => this.backDarkRef = ref}>
              <path d="M609.877333 97.962667A42.666667 42.666667 0 0 1 673.706667 154.453333l-3.541334 4.010667-353.792 352.426667 353.877334 355.242666a42.666667 42.666667 0 0 1-56.405334 63.786667l-4.010666-3.541333-353.92-355.285334a85.333333 85.333333 0 0 1-4.736-115.285333l4.992-5.418667 353.749333-352.384z" p-id="1697" fill="#000000"></path>
            </svg>
          </div>
        </div>
        <div
          className={`share-icon-wrap ${isTabletDevice ? 'isTablet' : ''}`}
          onClick={this.shareClick}
        >
          <div className="share-icon-bg" ref={ref => this.shareRef = ref}>
            <svg t="1657000501157" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1529" width="24" height="24" className="share-icon-light" ref={ref => this.shareLightRef = ref}>
              <path d="M367.616 128a42.666667 42.666667 0 0 1 4.992 85.034667L367.616 213.333333H235.050667a21.333333 21.333333 0 0 0-20.992 17.493334l-0.341334 3.84v554.666666a21.333333 21.333333 0 0 0 17.493334 20.992l3.84 0.341334h554.197333a21.333333 21.333333 0 0 0 20.949333-17.493334l0.384-3.84v-358.912a42.666667 42.666667 0 0 1 85.034667-4.992l0.298667 4.992V789.333333a106.666667 106.666667 0 0 1-99.669334 106.453334l-6.997333 0.213333H235.008a106.666667 106.666667 0 0 1-106.410667-99.669333L128.426667 789.333333v-554.666666a106.666667 106.666667 0 0 1 99.626666-106.453334L235.093333 128h132.565334z m455.552 0a64 64 0 0 1 45.226667 109.226667 42.666667 42.666667 0 0 1-16.042667 10.112c-99.626667 34.858667-180.864 83.968-244.181333 147.285333-62.293333 62.336-101.546667 132.650667-118.442667 211.626667a42.666667 42.666667 0 0 1-83.456-17.834667c20.394667-95.402667 67.84-180.352 141.568-254.122667a665.216 665.216 0 0 1 159.146667-116.565333l8.533333-4.437333L599.637333 213.333333a42.666667 42.666667 0 0 1-42.368-37.674666L556.970667 170.666667a42.666667 42.666667 0 0 1 37.674666-42.368L599.637333 128h223.530667z" p-id="1530" fill="#ffffff"></path>
            </svg>
            <svg t="1657000501157" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1529" width="24" height="24" className="share-icon-dark" ref={ref => this.shareDarkRef = ref}>
              <path d="M367.616 128a42.666667 42.666667 0 0 1 4.992 85.034667L367.616 213.333333H235.050667a21.333333 21.333333 0 0 0-20.992 17.493334l-0.341334 3.84v554.666666a21.333333 21.333333 0 0 0 17.493334 20.992l3.84 0.341334h554.197333a21.333333 21.333333 0 0 0 20.949333-17.493334l0.384-3.84v-358.912a42.666667 42.666667 0 0 1 85.034667-4.992l0.298667 4.992V789.333333a106.666667 106.666667 0 0 1-99.669334 106.453334l-6.997333 0.213333H235.008a106.666667 106.666667 0 0 1-106.410667-99.669333L128.426667 789.333333v-554.666666a106.666667 106.666667 0 0 1 99.626666-106.453334L235.093333 128h132.565334z m455.552 0a64 64 0 0 1 45.226667 109.226667 42.666667 42.666667 0 0 1-16.042667 10.112c-99.626667 34.858667-180.864 83.968-244.181333 147.285333-62.293333 62.336-101.546667 132.650667-118.442667 211.626667a42.666667 42.666667 0 0 1-83.456-17.834667c20.394667-95.402667 67.84-180.352 141.568-254.122667a665.216 665.216 0 0 1 159.146667-116.565333l8.533333-4.437333L599.637333 213.333333a42.666667 42.666667 0 0 1-42.368-37.674666L556.970667 170.666667a42.666667 42.666667 0 0 1 37.674666-42.368L599.637333 128h223.530667z" p-id="1530" fill="#000000"></path>
            </svg>
          </div>
        </div>
      </div>
    );
  }
}

PipelineNavigationBar.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineNavigationBar };
export default PipelineNavigationBar;



// WEBPACK FOOTER //
// ./templates/zhuanti/src/baseComponents/navigation-bar/index.js